import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { WorkshopAssignedHolderTariffs, WorkshopAvailableSeats } from '@products/models/workshop-status.model';

export const WorkshopStatusActions = createActionGroup({
  source: 'Workshop Status',
  events: {
    'Set workshop available seats status': (availableSeats: WorkshopAvailableSeats) => ({ availableSeats }),
    'Set workshop assigned holder tariffs status': (assignedHolderTariffs: WorkshopAssignedHolderTariffs) => ({
      assignedHolderTariffs
    }),
    'Set workshop available seats and assigned holder tariffs status': props<{
      availableSeats: WorkshopAvailableSeats;
      assignedHolderTariffs: WorkshopAssignedHolderTariffs;
    }>(),
    'Set is workshop loading status': (isWorkshopLoading: boolean) => ({ isWorkshopLoading }),
    'Set initial is workshop detail modal open status': emptyProps(),
    'Set is workshop detail modal open status': (isWorkshopDetailModalOpen: boolean) => ({ isWorkshopDetailModalOpen }),
    'Toggle is workshop detail modal open status': emptyProps(),
    'Reset reducer': emptyProps()
  }
});
